/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Section } from '../models/section';
@Injectable({
  providedIn: 'root',
})
class ContentManagementService extends __BaseService {
  static readonly getContentmanagementSectionsPath = '/contentmanagement/sections';
  static readonly getContentmanagementSectionsAskeyvaluePath = '/contentmanagement/sections/askeyvalue';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Get a JSON of all Section IDs with the corresponding Section Text
   *
   * Returns an array of Section objects by default.
   * @return Successful operation
   */
  getContentmanagementSectionsResponse(): __Observable<__StrictHttpResponse<Array<Section>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/contentmanagement/sections`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Section>>;
      })
    );
  }
  /**
   * Get a JSON of all Section IDs with the corresponding Section Text
   *
   * Returns an array of Section objects by default.
   * @return Successful operation
   */
  getContentmanagementSections(): __Observable<Array<Section>> {
    return this.getContentmanagementSectionsResponse().pipe(
      __map(_r => _r.body as Array<Section>)
    );
  }

  /**
   * Get a JSON of all Section IDs with the corresponding Section Text
   *
   * Returns a JSON object where each key is a `sectionId` and each value is the corresponding `sectionText`.
   * Example: {"sectionId1": "sectionText1", "sectionId2": "sectionText2"}.
   * @return Successful operation. Example response:
   * {
   *   "sectionId1": "sectionText1",
   *   "sectionId2": "sectionText2"
   * }
   */
  getContentmanagementSectionsAskeyvalueResponse(): __Observable<__StrictHttpResponse<{[key: string]: string}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/contentmanagement/sections/askeyvalue`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: string}>;
      })
    );
  }
  /**
   * Get a JSON of all Section IDs with the corresponding Section Text
   *
   * Returns a JSON object where each key is a `sectionId` and each value is the corresponding `sectionText`.
   * Example: {"sectionId1": "sectionText1", "sectionId2": "sectionText2"}.
   * @return Successful operation. Example response:
   * {
   *   "sectionId1": "sectionText1",
   *   "sectionId2": "sectionText2"
   * }
   */
  getContentmanagementSectionsAskeyvalue(): __Observable<{[key: string]: string}> {
    return this.getContentmanagementSectionsAskeyvalueResponse().pipe(
      __map(_r => _r.body as {[key: string]: string})
    );
  }
}

module ContentManagementService {
}

export { ContentManagementService }
